import React from "react";
import { observer } from "mobx-react";
import { makeObservable, observable, runInAction } from "mobx";

import { BrowserRouter, Routes, Route } from "react-router-dom";

import ErrorBoundary from "./components/ErrorBoundary";
import Page404 from "./pages/Page404";
import Translate from "./pages/Translate";
import ClientError from "./pages/ClientError";
import LoginPage from "./pages/LoginPage";

import './App.css';
import './Scrollbars.css';
import './components/ContextMenu/_context-menu.scss';
import apiService from "./services/apiService";


type UserData = { role: string; tokensLeft: number; picture?: string; name?: string; given_name?: string; family_name?: string; email: string; emailMd5: string; id: string };
declare global {
  interface Window {
    user?: UserData;
  }
}

@observer
class App extends React.Component {
  @observable UserData = window.user;
  @observable isLoading = true;

  constructor(props: {}) {
    super(props);
    makeObservable(this);
  }

  componentDidMount(): void {
    void this._checkUserLoggedIn();
  }

  render(){

    if (this.isLoading) {
      return null;
    }

    let isLoggedIn = !!window.user;

    return (
    <BrowserRouter>
      <ErrorBoundary fallback={(e) => <ClientError error={e} />}>
        <Routes>
          {!isLoggedIn ? (
            <Route path="*" element={<LoginPage />} />
          ) : (
            <>
              <Route path="/" element={<Translate />} />
              <Route path="*" element={<Page404 />} />
            </>
          )}
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
  }

  private async _checkUserLoggedIn() {
    let isLoggedIn = !!window.user;
    if (!isLoggedIn) {
      const userDataResponse = await fetch('/auth/userinfo');
      if (userDataResponse.ok) {
        const userData: { isAuthenticated: boolean; user?: UserData; hasRefreshToken?: boolean } = await userDataResponse.json();
        if (userData.isAuthenticated && userData.user) {
          window.user = userData.user;
          this.UserData = userData.user;
          isLoggedIn = true;
        }
        if (userData.hasRefreshToken) {
          await apiService.refreshToken(void 0, false);
        }
      }

    }

    runInAction(() => {
      this.isLoading = false;
    });
  }
};

export default App;